import type { BinaryFeatureCollection } from "@loaders.gl/schema";
import { CustomPMTilesMVTLayer } from "common/functions/classes/CustomPMTilesMVTLayer";
import { TileLoadProps } from "common/types/TileLoadProps";

export class YoutoMVTPolygonLayer<
  ExtraProps extends object
> extends CustomPMTilesMVTLayer<ExtraProps> {
  getPMTilesPath(): string {
    return "json/use_districts/tiles/z04-20.pmtiles";
  }

  async getTileData(
    loadProps: TileLoadProps
  ): Promise<BinaryFeatureCollection> {
    const data = await super.getTileData(loadProps);

    return data;
  }
}
